/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Mfa_Error_Account_LockedInputs */

const de_auth_mfa_error_account_locked = /** @type {(inputs: Auth_Mfa_Error_Account_LockedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Konto wurde gesperrt. Bitte kontaktieren Sie den Support.`)
};

/** @type {(inputs: Auth_Mfa_Error_Account_LockedInputs) => LocalizedString} */
const en_auth_mfa_error_account_locked = de_auth_mfa_error_account_locked;

/**

* @param {Auth_Mfa_Error_Account_LockedInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_mfa_error_account_locked = /** @type {((inputs?: Auth_Mfa_Error_Account_LockedInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Mfa_Error_Account_LockedInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_mfa_error_account_locked(inputs)
	return en_auth_mfa_error_account_locked(inputs)
});